export default "__VITE_ASSET__2aCQu_dZ__"